var _path, _path2, _path3, _path4, _line, _line2, _path5, _path6, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlexability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 0H11C4.92487 0 0 4.92487 0 11V46C0 52.0751 4.92487 57 11 57H46C52.0751 57 57 52.0751 57 46V11C57 4.92487 52.0751 0 46 0Z",
    fill: "#FFB601"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30L44.284 25.6987L45.917 37.1297L55 30ZM41.1414 32.9899L46.2319 32.2627L45.949 30.2828L40.8586 31.0101L41.1414 32.9899Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 4L20.3397 19L37.6603 19L29 4ZM30.5 18L30.5 17.5L27.5 17.5L27.5 18L30.5 18Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 29L10.5683 36.7406L12.9877 25.4499L2 29ZM16.2095 31.0222L11.0098 29.908L10.5907 31.8636L15.7905 32.9778L16.2095 31.0222Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 56,
    x2: 29,
    y2: 17,
    stroke: "black",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 56,
    x2: 29,
    y2: 17,
    stroke: "black",
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.036 55.3879C29.0369 46.3172 22.7223 31.3226 9.5 31.3238M29.0422 55.3925C29.0431 46.3218 34.5009 31.3229 47 31.3231",
    stroke: "black",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.036 55.3879C29.0369 46.3172 22.7223 31.3226 9.5 31.3238M29.0422 55.3925C29.0431 46.3218 34.5009 31.3229 47 31.3231",
    stroke: "#FFB601",
    strokeDasharray: "2 2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 55.5,
    x2: 29,
    y2: 17.5,
    stroke: "#FFB601",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexability);
export default __webpack_public_path__ + "static/media/flexability.ea9f3272bf17d6756d4a09d057f39b5f.svg";
export { ForwardRef as ReactComponent };